/**
 * Created by jonas on 2021-03-04.
 */
import {DasUBootSymbolStates} from "../DasUBootSymbol";
import {gsap} from "gsap";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootGameAssets} from "../../DasUBootGameAssets";
import {SpineGSAPWrapper} from "../../../core/animation/SpineGSAPWrapper";
import {DasUBootReel} from "../DasUBootReel";
import {DasUBootSound} from "../../sound/DasUBootSound";
import {DasUBootStatics} from "../../utils/DasUBootStatics";
import {SpineSymbol} from "./SpineSymbol";

export function isBombSymbol(value:any):value is BombSymbol {
    return value.symbolName === "B" || value.symbolName === "BB";
}
export function isNewBombSymbol(value:any):value is BombSymbol {
    return value.symbolName === "B";
}


export class BombSymbol extends SpineSymbol {

    constructor(reel:DasUBootReel, symbolName:string) {
        super(reel, symbolName, DasUBootGameAssets.BOMB_SYMBOL_SPINE);
    }

    public getStateAnimation(state:DasUBootSymbolStates):gsap.core.Timeline {
        let tl:gsap.core.Timeline = gsap.timeline();


        switch (state) {
            case DasUBootSymbolStates.NORMAL:
                tl.add(() => this.setState(state));
                tl.add(() => this.moveToNormalLayer());
                if (this.symbolName == "BB") {
                    tl.add(()=>{this.getSpineAnimation("idleExploded", 0, true, -1)});
                } else {
                    tl.add(this.getSpineAnimation("idle", 0, true, -1));
                }
                break;
            case DasUBootSymbolStates.FLASH:
                tl.add(() => this.setState(state));
                tl.add(this.getSpineAnimation("flash", 0, true));
                break;

            case DasUBootSymbolStates.LANDING:
                if (!this.isVisibleInReel()) {
                    return super.getStateAnimation(state);
                }
                tl.add(() => this.setState(state));
                tl.add(() => this.moveToNormalLayer());
                tl.add(() => DasUBoot.soundPlayer.playSingleSound(DasUBootSound.BOMB_LANDING_SOUND));
                tl.add(() => {DasUBoot.reelView.getLandingShake(false).play(0)});

                tl.add(this.getSpineAnimation("landing", 0, true));
                tl.add(this.getStateAnimation(DasUBootSymbolStates.NORMAL));
                break;
            case DasUBootSymbolStates.EXPLODE:
                if (this.symbolName == "BB") {
                    return this.getStateAnimation(DasUBootSymbolStates.NORMAL);
                }
                this.symbolName = "BB";
                if (this._stateAnimation) {
                    const prevTl = this._stateAnimation;
                    tl.add(() => {
                        prevTl.kill();
                    });
                }
                tl.add(() => this.setState(state));
                tl.add(() => this.moveToWinLayer());

                tl.add(this.getExplosion());
                tl.add(()=>{this.getSpineAnimation("idleExploded", 0, true, -1)});
                break;
            case DasUBootSymbolStates.COLLAPSE:
                tl = this.getStateAnimation(DasUBootSymbolStates.NORMAL);
                break;
            case DasUBootSymbolStates.WIN:
                tl = super.getStateAnimation(state);
                tl.add(() => this.removeSpineFromView(),0);
                break;
            default:
                tl = super.getStateAnimation(state);
                tl.add(() => this.removeSpineFromView());

        }

        this._stateAnimation = tl;
        return tl;
    }

    private getExplosion():gsap.core.Timeline {
        const explosionPool = DasUBoot.graphicsPool.getSpinePool(DasUBootGameAssets.BOMB_SYMBOL_EXPLOSION_SPINE);
        const spine = explosionPool.withdraw();
        spine.position.set(DasUBootStatics.symbolWidth * 0.5, DasUBootStatics.symbolHeight * 0.5 * this.resizeScale);
        const tl = gsap.timeline();
        tl.add(() => {
            this.view.addChild(spine);
            spine.updateTransform();
        });
        tl.add([
            SpineGSAPWrapper.createTimeline(spine, 0, "explosion"),
            this.getSpineAnimation("explosion", 0, true)
        ]);
        tl.add(() => {
            SpineGSAPWrapper.createTimeline(spine, 0, null);
            this.view.removeChild(spine);
            explosionPool.deposit(spine);
        });

        return tl;
    }

}